export default __webpack_public_path__ + "static/media/1920 knife block B top.750d3efe.png";